/**
 * Transliterate text
 * @param {*} string
 */
export const translitraite = string => {
	return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

/**
 * Export validation
 */
export const errorValidation = {
	errorPlacement: function (error, element) {
		if (element.is(':checkbox')) {
			error.insertAfter(element.closest('.checkbox-wrapper'));
		} else if (element.is(':radio')) {
			error.insertAfter(element.closest('.radio-wrapper'));
		} else if (element.is(':file')) {
			error.insertAfter(element.closest('.file-wrapper'));
		} else if (element.is('select')) {
			error.insertAfter(element.closest('.select-wrapper'));
		} else {
			error.insertAfter(element.closest('.input-wrapper'));
		}
	},
	highlight: element => {
		const $el = $(element);
		if ($el.is('select')) {
			const $item = $el.closest('.select-wrapper').find('.select__item');
			if (!$item.hasClass('_error')) {
				$item.addClass('_error');
			}
		} else if ($el.is(':radio')) {
			const $radioWrapper = $el.closest('.radio-wrapper');
			const $circle = $radioWrapper.find('.payment-main-order__circle');
			const $background = $radioWrapper.find('.payment-main-order__content');
			if (!$circle.hasClass('_error')) {
				$circle.addClass('_error');
			}
			if (!$background.hasClass('_error')) {
				$background.addClass('_error');
			}
		} else {
			if (!$el.hasClass('_error')) {
				$el.addClass('_error');
			}
		}
	},
	unhighlight: element => {
		const $el = $(element);
		if ($el.is('select')) {
			const $item = $el.closest('.select-wrapper').find('.select__item');
			if ($item.hasClass('_error')) {
				$item.removeClass('_error');
			}
		} else if ($el.is(':radio')) {
			const $radioWrapper = $el.closest('.radio-wrapper');
			const $circle = $radioWrapper.find('.payment-main-order__circle');
			const $background = $radioWrapper.find('.payment-main-order__content');
			if ($circle.hasClass('_error')) {
				$circle.removeClass('_error');
			}
			if ($background.hasClass('_error')) {
				$background.removeClass('_error');
			}
		} else {
			if ($el.hasClass('_error')) {
				$el.removeClass('_error');
			}
		}
	},
	invalidHandler: function (form, validator) {
		console.log(validator);

		if (!validator.numberOfInvalids()) return;

		$('html, body').animate(
			{
				scrollTop: $(validator.errorList[0].element).offset().top - 320,
			},
			1000
		);
	},
};
